import { render, staticRenderFns } from "./HelloNosotros.vue?vue&type=template&id=80345bb8"
import script from "./HelloNosotros.vue?vue&type=script&lang=js"
export * from "./HelloNosotros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports